import { __decorate, __metadata, __param } from "tslib";
import { Inject } from '@angular/core';
import { SharedService } from './shared.service';
var HistoryModelService = /** @class */ (function () {
    function HistoryModelService(sharedService) {
        this.sharedService = sharedService;
        this.history = [];
    }
    // Update the member exit state to 'Process started' or 'Process completed'
    HistoryModelService.prototype.addHistoryEntryWithExitState = function (exitState, stateId, action, description) {
        this.history.push({
            exitState: exitState,
            progressStateId: stateId,
            action: action,
            description: description
        });
    };
    HistoryModelService.prototype.addHistoryEntry = function (stateId, action, description) {
        this.history.push({
            progressStateId: stateId,
            action: action,
            description: description
        });
    };
    HistoryModelService.prototype.save = function (successCallBack) {
        var _this = this;
        this.sharedService.saveHistory({ history: this.history }).then(function () {
            // clear history because it was saved
            _this.history = [];
            successCallBack();
        });
    };
    HistoryModelService.prototype.clear = function () {
        this.history = [];
    };
    HistoryModelService = __decorate([
        __param(0, Inject(SharedService)),
        __metadata("design:paramtypes", [SharedService])
    ], HistoryModelService);
    return HistoryModelService;
}());
export { HistoryModelService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGlzdG9yeS1tb2RlbC5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9zZXJ2aWNlcy9oaXN0b3J5LW1vZGVsLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxNQUFNLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFFckMsT0FBTyxFQUFDLGFBQWEsRUFBQyxNQUFNLGtCQUFrQixDQUFDO0FBUy9DO0lBSUUsNkJBQWtELGFBQTRCO1FBQTVCLGtCQUFhLEdBQWIsYUFBYSxDQUFlO1FBRnRFLFlBQU8sR0FBRyxFQUFlLENBQUM7SUFFK0MsQ0FBQztJQUVsRiwyRUFBMkU7SUFDcEUsMERBQTRCLEdBQW5DLFVBQW9DLFNBQVMsRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLFdBQVc7UUFDekUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUM7WUFDaEIsU0FBUyxFQUFFLFNBQVM7WUFDcEIsZUFBZSxFQUFFLE9BQU87WUFDeEIsTUFBTSxFQUFFLE1BQU07WUFDZCxXQUFXLEVBQUUsV0FBVztTQUN6QixDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU0sNkNBQWUsR0FBdEIsVUFBdUIsT0FBTyxFQUFFLE1BQU0sRUFBRSxXQUFXO1FBQ2pELElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDO1lBQ2hCLGVBQWUsRUFBRSxPQUFPO1lBQ3hCLE1BQU0sRUFBRSxNQUFNO1lBQ2QsV0FBVyxFQUFFLFdBQVc7U0FDekIsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLGtDQUFJLEdBQVgsVUFBWSxlQUFlO1FBQTNCLGlCQU1DO1FBTEMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxXQUFXLENBQUMsRUFBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU8sRUFBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1lBQzNELHFDQUFxQztZQUNyQyxLQUFJLENBQUMsT0FBTyxHQUFHLEVBQUUsQ0FBQztZQUNsQixlQUFlLEVBQUUsQ0FBQztRQUNwQixDQUFDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFFTSxtQ0FBSyxHQUFaO1FBQ0UsSUFBSSxDQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7SUFDcEIsQ0FBQztJQWxDVSxtQkFBbUI7UUFJVixXQUFBLE1BQU0sQ0FBQyxhQUFhLENBQUMsQ0FBQTt5Q0FBd0IsYUFBYTtPQUpuRSxtQkFBbUIsQ0FtQy9CO0lBQUQsMEJBQUM7Q0FBQSxBQW5DRCxJQW1DQztTQW5DWSxtQkFBbUIifQ==